import React, { FC, useEffect } from 'react';
import { Form } from 'react-final-form';
import apiRoutes from '../../../../config/api/routes';
import { useFetch } from '../../../shared/hooks';
import { VersionRequest } from '../../../../config/api/models/Differentiation';
import { DifferentiationScreenAction } from './DifferentiationScreenAction';
import { DifferentiationForm } from './DifferentiationForm';
import { ScreenProps } from './DifferentiationsContainer';

export const UpdateDifferentiation: FC<ScreenProps> = ({
  openCallback,
  trajectoryId,
  metaData,
}) => {
  const [patchVersionInChapterResponse, patchVersionInChapter] = useFetch('', { method: 'PATCH' });

  useEffect(() => {
    if (patchVersionInChapterResponse.success) {
      openCallback(DifferentiationScreenAction.OVERVIEW, 'REFETCH');
    }
  }, [patchVersionInChapterResponse, openCallback]);

  return (
    <Form
      onSubmit={(values: VersionRequest) =>
        patchVersionInChapter({
          path: apiRoutes.trajectory(metaData.version ? metaData.version.id : ''),
          body: {
            title: values.title,
            parent_id: trajectoryId,
          },
        })
      }
      render={({ handleSubmit }) => (
        <DifferentiationForm
          handleSubmit={handleSubmit}
          version={metaData.version}
          openCallback={openCallback}
        />
      )}
    />
  );
};
